import * as React from "react";
import { cx } from "@emotion/css";
import formGroupStyles from "../css/formgroup.module.css";

interface PlainTextProps {
  label: string;
  text: string;
  id: string;
}

const PlainText = ({ label, text, id }: PlainTextProps): React.JSX.Element => {
  const fieldClasses = cx(formGroupStyles["form-group"]);

  return (
    <div className={fieldClasses}>
      <label htmlFor={label}>{label}</label>
      <div>
        <p id={id} className={formGroupStyles.bold}>
          {text}
        </p>
      </div>
    </div>
  );
};

export default PlainText;
